module.exports = vendor_0c73ff55ee48b0072eb8;